import Image from '@base/Image';
import styled from '@emotion/styled';
import { useRouter } from 'next/router';
import useWindowSize from '@hooks/useWindowSize';
import Divider from 'aquilla/core/atoms/Divider';
import { mediaQuery, Spacings } from '@styles/index';
import Typography from 'aquilla/core/atoms/Typography';
import Breadcrumbs from 'aquilla/core/molecules/Breadcrumbs';
import { APP_CONTAINER_WIDTH } from '@styles/constants/spacings';
import { useIsFromStore } from './utils';

const Header = styled.div`
  position: fixed;
  top: ${Spacings.SPACING_28B};
  width: ${APP_CONTAINER_WIDTH};

  ${mediaQuery.uptoMobile} {
    width: 100%;
    top: ${Spacings.SPACING_15B};
    padding: 0 ${Spacings.SPACING_4B};
  }
`;

const HeadingWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: ${Spacings.SPACING_4B} 0 ${Spacings.SPACING_8B};

  ${mediaQuery.uptoMobile} {
    margin-bottom: ${Spacings.SPACING_6B};
  }
`;

const Heading = styled(Typography)`
  margin-left: ${Spacings.SPACING_6B};

  ${mediaQuery.uptoMobile} {
    margin-left: ${Spacings.SPACING_4B};
  }
`;

const ScheduleHeader = () => {
  const {
    query: { slug, courseUID }
  } = useRouter();

  const fromStore = useIsFromStore();
  const { isMobile } = useWindowSize();

  const testSeriesLink = fromStore
    ? `/store/test-series/${slug}/${courseUID}`
    : `/test-series/${slug}/${courseUID}`;

  return (
    <Header>
      <Breadcrumbs
        fragments={[
          {
            title: 'Test page',
            url: testSeriesLink
          },
          {
            title: 'Full schedule',
            url: '#'
          }
        ]}
      />
      <HeadingWrapper>
        <Image
          src="store/test-series/schedule-header-icon.svg"
          width={isMobile ? 40 : 56}
          height={isMobile ? 40 : 56}
          alt=""
        />
        <Heading variant="h2">Full schedule</Heading>
      </HeadingWrapper>
      <Divider orientation="horizontal" />
    </Header>
  );
};

export default ScheduleHeader;
